// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__35Ktc","stolen":"Badge_stolen__YL4Sn","fullWidth":"Badge_fullWidth__1DKfW"};